import StocktakeBoxDetailDialog from "./stocktakeBoxDetailDialog.container";

export default StocktakeBoxDetailDialog;
